import { api } from '@/lib/api'
import type { SessionUser } from '@/types/api'
import { create } from 'zustand'

interface AuthStore {
  user: SessionUser | null
  isLoading: boolean
  setUser: (user: SessionUser | null) => void
  hydrate: () => Promise<void>
  logout: () => Promise<void>
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  isLoading: false,
  setUser: (user) => set({ user }),
  hydrate: async () => {
    set({ isLoading: true })
    const user = await api.me()
    set({ user, isLoading: false })
  },
  logout: async () => {
    await api.logout()
    set({ user: null })
  },
}))
